import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import PHQForm from "./PHQForm";

import { useDispatch, useSelector } from "react-redux";
import { fetchPhqAssessment, updatePhqAssessment } from "../../../store/slices/phqAssessmentsSlice";

const EditPHQ = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    // FIXED SELECTOR
    const {
        currentPhqAssessment,
        isLoading,
    } = useSelector((state) => state.phqAssessments);

    const [formData, setFormData] = useState({});

    // suffix mapping
    const keyMap = {
        1: "little_interest",
        2: "feeling_down",
        3: "sleep_issues",
        4: "low_energy",
        5: "appetite_issues",
        6: "feeling_bad",
        7: "concentration",
        8: "movement_changes",
        9: "self_harm"
    };

    // Fetch assessment
    useEffect(() => {
        dispatch(fetchPhqAssessment(id));
    }, [dispatch, id]);

    // Map backend → frontend
    useEffect(() => {
        if (!currentPhqAssessment) return;

        const mapped = {
            clientName: currentPhqAssessment.client_name || "",
            date: (currentPhqAssessment.created_at || "").split("T")[0],
            difficulty: currentPhqAssessment.difficulty || "",
            patientId: currentPhqAssessment.patient_id,
            caseId: currentPhqAssessment.case_id
        };

        for (let i = 1; i <= 9; i++) {
            const suffix = keyMap[i];
            const scoreField = `q${i}_${suffix}_score`;

            mapped[`q${i}`] =
                currentPhqAssessment[scoreField] !== undefined
                    ? String(currentPhqAssessment[scoreField])
                    : "0";
        }

        setFormData(mapped);
    }, [currentPhqAssessment]);

    // Handle form update
    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    // Build payload
    const buildPayload = () => {
        const labels = [
            "Not at all",
            "Several days",
            "More than half the days",
            "Nearly every day",
        ];

        const payload = {
            patient_id: formData.patientId,
            case_id: formData.caseId,
            client_name: formData.clientName,
            difficulty: formData.difficulty,
            status: "active",
        };

        for (let i = 1; i <= 9; i++) {
            const score = parseInt(formData[`q${i}`] || "0", 10);
            const value = labels[score] || "";

            const suffix = keyMap[i];

            payload[`q${i}_${suffix}_score`] = score;
            payload[`q${i}_${suffix}_value`] = value;
        }

        return payload;
    };

    // Submit update
    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = buildPayload();

        try {
            await dispatch(
                updatePhqAssessment({ case_id: caseId, assessmentData: payload })
            ).unwrap();

            Swal.fire("Updated!", "PHQ-9 assessment updated successfully.", "success");
            // Stay on edit page

        } catch (error) {
            Swal.fire("Error", error?.message || "Failed to update PHQ-9", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">

                        {isLoading ? (
                            <p>Loading assessment...</p>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <PHQForm formData={formData} handleChange={handleChange} />

                                <div className="col-12 d-flex justify-content-end mt-3">
                                    <div className="col-md-2 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-primary">
                                            <i className="ri-edit-2-line me-1"></i> Update
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}

                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default EditPHQ;
